    <div class="col-md-12 col-lg-9 create-batch-alert">
        <div class="container">
            <div class="row">
                <div class="col-md-12 title"> 
                    <h6>Create Batch Alert </h6>
                </div>
                </div>
                <div class="row">
                <div class="col-md-12">
                <section  class="error-wrapper">
                    <f-alert *ngIf="apiFailureMsg" variant="error" class="">
                        <p class="full-width">
                            There was a problem saving the data. Try again.
                        </p>
                    </f-alert>
                    <f-alert *ngIf="showAlertSuccessMsg" variant="success" >
                        <p class="full-width">
                            Batch alert was created successfully.Batch ID: {{batchAlertService.batchId}} .  Num of Records:  {{batchAlertService.alertCount}}
                        </p>
                    </f-alert>

                </section>
              </div>  
            </div>
        <form id="batchAlertForm" [formGroup]="batchAlertService.createAlertForm">
            <div class="row row-bottom-space1">
                <div class="col-md-6">                   
                    <mat-form-field appearance="fill" class="component-box">
                        <mat-label>Type</mat-label>
                        <mat-select disableRipple disableOptionCentering formControlName="alertType">
                            <mat-option *ngFor="let alertType of batchAlertService.alertTypes" [value]="alertType.type"
                                (onSelectionChange)="changeAlertType(alertType, $event)">
                                {{ alertType.type }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field appearance="fill" class="component-box">
                        <mat-label>Subtype</mat-label>
                        <mat-select disableRipple disableOptionCentering disableRipple formControlName="alertSubType"
                            disableOptionCentering>
                            <mat-option *ngFor="let alertSubType of batchAlertService.subAlertTypes" [value]="alertSubType.subType"
                                (onSelectionChange)="alertSubTypeSelection(alertSubType,$event)">
                                {{ alertSubType.subType }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>                          
                </div>                
            </div>

            <div class="row">
                <div class="col-md-6 flex">
                    <mat-form-field appearance="fill" class="component-box">
                        <mat-label>Start Date (MMM-DD-YYYY)</mat-label>
                        <input matInput [matDatepicker]="picker1" [min]="batchAlertService.todayDate" [max]="batchAlertService.maxStartDate"
                            formControlName="start" (dateChange)="addEvent( $event)"  />
                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                      <mat-error *ngIf="errorHandling()">
                        <i class="fa-solid fa-circle-xmark"></i>
                        {{ errorMessages }}
                      </mat-error>
                    </mat-form-field>

                    
                </div>
                
                <div class="col-md-6 flex">
                    <mat-form-field appearance="fill" class="component-box">
                      <mat-label>End Date (MMM-DD-YYYY)</mat-label>
                      <input matInput [matDatepicker]="picker2" [min]="batchAlertService.createAlertForm.value.start" [max]="batchAlertService.maxEndDate"
                          formControlName="end" />
                      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                      <mat-datepicker #picker2></mat-datepicker>
                      <mat-error *ngIf="errorHandling()">
                        <i class="fa-solid fa-circle-xmark"></i>
                        {{ displayErrorMessage }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  
                
            </div>
        
            <div class="row">                        
                <div class="col-md-12">
                <mat-form-field appearance="fill" class="component-box error-border">
                    <mat-label>Title</mat-label>
                    <input matInput formControlName="title" id="title" />
                </mat-form-field>
                </div>
            </div> 
            <div class="row">
                <div class="col-md-12">

                    <f-textarea label-text="Details" formControlName="detail"></f-textarea>
                </div>
            </div>
            <div class="row">  
                <p class="hints">Person File (the file should be a single column, with no header, containing Global UDP Person ID, and in .TXT format)</p>
                                       
            </div>    
            <div class="row">  
                <div class="col-md-10 col-lg-11 attach-file">                                                      
                    <mat-form-field appearance="fill" class="component-box">
                        <mat-label>Person file</mat-label>
                        <input matInput [value]="batchAlertService.fileText" readonly formControlName="personFile" id="person-file" (click)="openFile()" />
                    </mat-form-field>
                    </div>
                    <div class="col-md-2 col-lg-1  attach-file-CTA">
                        <f-button text="Browse" title="Browse" type="button" 
                        variant="progressive" (click)="openFile()">
                            <input type="file"  accept=".txt" #fileInput class="hide" (change)="fileUpload($event)" />
                          </f-button>
                    </div>
            </div> 
            <div class="row">                        
                <div class="col-md-12">
                <mat-form-field appearance="fill" class="component-box error-border">
                    <mat-label>Description</mat-label>
                    <input matInput   formControlName="description" id="description" />
                </mat-form-field>
                </div>
            </div> 

            <div class="button-controls">
                <f-button text="Create" title="Create" [ngClass]="{disableBtn: batchAlertService.createAlertForm.invalid}" [disabled]="batchAlertService.createAlertForm.invalid"  (click)="onSubmit()"
                    variant="progressive"></f-button>
            </div>
        </form>    
        </div>
    </div>  
     
    
